import React from 'react';
import { useI18n } from '../hooks/useI18n';

// Fruit data with local SVG paths from CISH
const fruits = [
  { id: 'mango', name: 'Mango', nameHi: 'आम', icon: '/icons/mango.svg' },
  { id: 'guava', name: 'Guava', nameHi: 'अमरूद', icon: '/icons/guava.svg' },
  { id: 'bael', name: 'Bael', nameHi: 'बेल', icon: '/icons/bael.svg' },
  { id: 'jamun', name: 'Jamun', nameHi: 'जामुन', icon: '/icons/jamun.svg' },
  { id: 'gooseberry', name: 'Indian Gooseberry', nameHi: 'आंवला', icon: '/icons/gooseberry.svg' },
  { id: 'banana', name: 'Banana', nameHi: 'केला', icon: '/icons/banana.svg' },
  { id: 'avocado', name: 'Avocado', nameHi: 'एवोकाडो', icon: '/icons/avocado.svg' },
];

export default function FruitIcons() {
  const { language, t } = useI18n();

  return (
    <section className="py-6 md:py-12 bg-white" data-testid="fruit-icons">
      <div className="container-cish text-center">
        {/* Pioneer text - bold green, centered - Mobile optimized */}
        <p className="text-[#1B5E20] text-sm md:text-xl lg:text-[25px] font-bold mb-4 md:mb-8 leading-tight px-2">
          WE ARE PIONEERS IN SUBTROPICAL FRUIT RESEARCH SPANNING FROM CLIMATE
          <br className="hidden md:block" />
          RESILIENT VARIETIES TO VALUE CHAIN RESEARCH.
        </p>

        {/* Fruit icons - square boxes with borders like original CISH */}
        <div className="flex flex-wrap justify-center gap-2 md:gap-4 lg:gap-[60px]">
          {fruits.map((fruit) => (
            <div
              key={fruit.id}
              className="flex flex-col items-center p-1 md:p-2 group cursor-pointer"
              data-testid={`fruit-${fruit.id}`}
            >
              {/* Square box with border - matches original CISH mobile */}
              <div className="border border-gray-300 hover:shadow-md p-1.5 md:p-2 flex items-center justify-center w-16 h-16 md:w-24 md:h-24 group-hover:bg-green-50 group-hover:border-green-600 transition-all">
                <img 
                  src={fruit.icon} 
                  alt={fruit.name} 
                  className="w-8 h-10 md:w-[50px] md:h-[60px] object-contain"
                  loading="lazy"
                />
              </div>
              {/* Label */}
              <p className="mt-1 md:mt-3 text-[10px] md:text-sm font-semibold uppercase text-gray-700 group-hover:text-green-700 transition-colors">
                {language === 'hi' ? fruit.nameHi : fruit.name}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
